import {ProcessSelectorModel} from "./process-selector.model";
import {MasterOperationModel} from "./master-operation.model";
import {Type} from "class-transformer";

export class IntegratedMasterModel {
  @Type(() => ProcessSelectorModel)
  ProcessSelectors: ProcessSelectorModel[] = [];
  @Type(() => MasterOperationModel)
  MasterOperations: MasterOperationModel[] = [];
}
